import { Typography } from '@material-ui/core'
import { useSectionTitleStyles } from './styles'

const SectionTitle = ({ title }) => {
  const styles = useSectionTitleStyles()
  return <Typography className={styles.title}>{title}</Typography>
}

export default SectionTitle
